// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Check or Card payment transaction model
*/
export class ClaimPaymentBatchDetailTransactionModel {
    /**
    * @description Claim Group ID that funds were recovered from, null if transaction did not recovery any funds
    */
    'fundsRecoveredFromClaimGroupId'?: number | null;
    /**
    * @description Amount requested on payment transaction
    */
    'expectedAmount'?: number;
    /**
    * @description Member Number
    */
    'memberNumber'?: string | null;
    /**
    * @description Actual Amount of transaction
    */
    'actualAmount'?: number | null;
    /**
    * @description Informational Message or Error Message describing transaction
    */
    'message'?: string | null;
    /**
    * @description Date of transaction
    */
    'transactionDate'?: Moment;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClaimPaymentBatchDetailTransactionModel>> = [
        {
            "name":     "fundsRecoveredFromClaimGroupId",
            "baseName": "fundsRecoveredFromClaimGroupId",
            "type":     "number"
        },
        {
            "name":     "expectedAmount",
            "baseName": "expectedAmount",
            "type":     "number"
        },
        {
            "name":     "memberNumber",
            "baseName": "memberNumber",
            "type":     "string"
        },
        {
            "name":     "actualAmount",
            "baseName": "actualAmount",
            "type":     "number"
        },
        {
            "name":     "message",
            "baseName": "message",
            "type":     "string"
        },
        {
            "name":     "transactionDate",
            "baseName": "transactionDate",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return ClaimPaymentBatchDetailTransactionModel.attributeTypeMap;
    }
}
